module.exports = __webpack_public_path__ + "static/media/3.c5ff0f77.png";